export default "__VITE_ASSET__CHDqK8p9__"